import { ReactNode, Ref } from 'react';

import { Alert, AlertDescription, AlertProps, AlertTitle } from '@britishcouncil/react-registration-platform';

import { AlertIconVariants } from './AlerIconVariants';

export type AlertRegProps = Omit<AlertProps, 'content'> & { content: ReactNode; title: ReactNode; visible?: boolean; ref?: Ref<HTMLDivElement> };

//Rename to Alert after remove legacy Alert component
export const AlertReg = ({ variant, content, visible = true, title, ref, ...props }: AlertRegProps) => {
  return (
    visible && (
      <Alert variant={variant} {...props} ref={ref}>
        {variant && AlertIconVariants[variant]}
        <AlertTitle>{title}</AlertTitle>
        <AlertDescription>{content}</AlertDescription>
      </Alert>
    )
  );
};
